import React, { PropsWithChildren } from 'react';

type Props = { isDetailsPage?: boolean };
export default ({ children, isDetailsPage }: PropsWithChildren<Props>) => (
  <div className={`top-panel ${isDetailsPage ? 'top-panel-details' : ''}`}>
    <div className='inner-top'>{children}</div>
  </div>
);
